import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";
import {$agentsFactory} from "../../$agents.factory";
import {CommonsService} from "../../../commons/services/commons-service.service";
import {TeamModel} from "../../../teams/models/team.model";

export class AgentMultiSelectListCtrl implements IController {

  selectAllOnInit: boolean;
  selectedIds: string[];
  optionIds: string[];
  branchIds: any;
  agentTypes: any;
  carrierIds: any;
  tags?: string[];
  skills?: string[];
  showTags?: string[];
  ngPlaceholder: any;
  selectedTeams: TeamModel[] = [];
  teamIds: string[];
  isHideTeamsFilter: boolean;
  onTeamsFilterChange: Function;
  onChange: Function;

  private agentsRef: any;
  private loadLimit: number;
  private infiniteScroll: any;
  private queryString: any;
  private selectedKeys: any;
  public isSelectAll: boolean;
  public selectedTeamIds: string[];
  public subFilterQueryMap: any;
  public includedSubFilters: any;

  constructor(private $agents: $agentsFactory, private $infiniteScroll, private $log, private commonsService: CommonsService) {
  }

  $onInit() {
    this.agentsRef = this.$agents();
    this.loadLimit = 30;

    this.agentsRef.$query(this._getQueryPayload());
    this.infiniteScroll = this.$infiniteScroll(this.agentsRef, this.loadLimit, {getFullData: true});

    this.subFilterQueryMap = {
      tagType: 'Agent'
    }

    this.includedSubFilters = ['tags'];

    if (!this.isHideTeamsFilter) {
      this.includedSubFilters.push('teams');
    }
  }

  $onChanges(changes) {
    if (changes.selectedIds) {
      this.selectedKeys = [];
      _.forEach(this.selectedIds, (id) => {
        this.selectedKeys[id] = true;
      })
    }

    if (changes.selectedTeams && !changes.selectedTeams.isFirstChange()) {
      this.selectedTeamIds = this.selectedTeams.map(t => t.id) || [];
      this._reload();
    }

    if (changes.teamIds && !changes.teamIds.isFirstChange()) {
      this._reload();
    }
  }

  onToggle(agentId: string, isSelected) {
    this.onChange({
      agentIds: isSelected ? _.concat(this.selectedIds || [], [agentId]) :
        _.filter(this.selectedIds, (id) => {
          return id !== agentId;
        })
    });
  }

  setSelectedOnInit() {
    if (!!this.selectAllOnInit) {
      this.selectAllOnInit = false
      const agentsToSelect = this.infiniteScroll.getItems();
      if (agentsToSelect.length && agentsToSelect.length < this.loadLimit) {
        this.onChange({agentIds: _.map(agentsToSelect, 'id')});
      }
    }
  }

  submitQuery(query) {
    this.queryString = query;
    this._reload();
  }

  onToggleSelectAll() {
    if (this.isSelectAll) {
      this.onChange({agentIds: []});
    } else {
      this.onChange({agentIds: this.infiniteScroll?.getItems()?.map((agent) => agent.id)});
    }
  }

  isAllSelected() {
    this.isSelectAll = this.commonsService.checkIfArraysMatch(this.infiniteScroll?.getItems().map(agent => agent.id), this.selectedIds);
    return this.isSelectAll;
  }

  onChangeFilters(tags, teams) {
    this.tags = tags;

    const teamsToAdd = _.difference(this.selectedTeams, teams);
    const teamsToRemove = _.difference(teams, this.selectedTeams);

    if (teamsToAdd?.length || teamsToRemove?.length) {
      this.onTeamsFilterChange({teams: teams})
    } else {
      this._reload();
    }
  }

  private _reload() {
    this.agentsRef.$query(this._getQueryPayload())
      .then(() => {
        this.infiniteScroll.reload();
      })
      .catch((error) => {
        this.$log.error('Fail to $query', error);
      })
  }

  private _getQueryPayload() {
    const mergedTeamIds = _.uniq(_.compact([...(this.teamIds || []), ...(this.selectedTeamIds || [])]));

    return {
      limit: this.loadLimit,
      ids: this.optionIds,
      query: this.queryString,
      branchIds: this.branchIds,
      agentTypes: this.agentTypes,
      accountIds: this.carrierIds,
      tags: this.tags,
      skill: this.skills,
      teamIds: mergedTeamIds.length ? mergedTeamIds : undefined,
      expandAgent: false,
      sort: 'firstName,asc',
      active: true
    };
  }

}

angular
  .module('bringoz.admin.agents')
  .component('agentMultiSelectList', {
    bindings: {
      selectAllOnInit: '<?',
      optionIds: '<?',
      selectedIds: '<',
      branchIds: '<?',
      agentTypes: '<?',
      carrierIds: '<?',
      tags: '<?',
      skills: '<?',
      showTags: '<?',
      isHideTeamsFilter: '<?',
      selectedTeams: '<?',
      teamIds: '<?',
      ngPlaceholder: '@?',
      onChange: '&',
      onTeamsFilterChange: '&'
    },
    template: require('./agent-multi-select-list.html').default,
    controller: AgentMultiSelectListCtrl
  });
